import React from "react";
import sanitizeHtml from 'sanitize-html';
import sanitizeWhiteList from '../sanitize-html.whitelist';
import {InfiosLearnMore} from "./LearnMore.style";
import Button from "../Button/Button";

const LearnMore = (props) => {
    const { id, className, content } = props;
    const { learnMoreDescription, learnMoreLinkTitle, learnMoreLink, learnMoreTargetLink } = content;
    return (
        <InfiosLearnMore id={id} className={className}>
            {learnMoreDescription && <p className="richtext" dangerouslySetInnerHTML={{
                __html: sanitizeHtml(learnMoreDescription, sanitizeWhiteList)
            }}></p>}
            {learnMoreLink && <Button onClick={()=> {window.open(learnMoreLink, learnMoreTargetLink); return false;}} icon="play" text={learnMoreLinkTitle} inverted/>}
        </InfiosLearnMore>
    )
}

export default LearnMore;
